/* Components  */
import Header from "../components/common/Header";
import Icon from "../components/common/Icon";
import { useNavigate } from "react-router-dom";


export default function Unauthorized() {
    const sources = ["fa fa-exclamation-triangle"];
    const navigate = useNavigate();
    const goback = () => navigate(-1);

    return (
        <main>
            <Header location="Page non autorisée" parent="" />
            <div className="content-wrapper flex">
                <section className="static-page">
                    <div className="dashboard">
                        <Icon source={sources} color="blue missing" span="Vous n'êtes pas autorisé à visiter cette page." />
                        <button onClick={goback}>Retour</button>
                    </div>
                </section>
            </div>
        </main>
    )
}